import moment from 'moment-timezone';

const FAKE_BATCHES = [
  {
    key: 'be4a134d-b14a-47c9-9c2d-ddbfcb5803e1',
    deadline: moment.now(),
    documentsCount: 1,
    document: {
      contentName: 'Nome-do-documento.pdf',
      signAs: ['sign'],
    },
    account: {
      name: 'Nome-do-remetente',
      documentation: '000.000.000-00',
      kind: 'person',
    },
    links: {
      self: '',
    },
    signable: true,
  },
  {
    key: 'be4a134d-b14a-47c9-9c2d-ddbfcb5803e2',
    deadline: moment.now(),
    documentsCount: 1,
    document: {
      contentName: 'Nome-do-documento.pdf',
      signAs: ['sign'],
    },
    account: {
      name: 'Nome-do-remetente',
      documentation: '000.000.000-00',
      kind: 'person',
    },
    links: {
      self: '',
    },
    signable: true,
  },
  {
    key: 'be4a134d-b14a-47c9-9c2d-ddbfcb5803e3',
    deadline: moment.now(),
    documentsCount: 1,
    document: {
      contentName: 'Nome-do-documento.pdf',
      signAs: ['sign'],
    },
    account: {
      name: 'Nome-do-remetente',
      documentation: '000.000.000-00',
      kind: 'person',
    },
    links: {
      self: '',
    },
    signable: true,
  },
  {
    key: 'be4a134d-b14a-47c9-9c2d-ddbfcb5803e4',
    deadline: moment.now(),
    documentsCount: 1,
    document: {
      contentName: 'Nome-do-documento.pdf',
      signAs: ['sign'],
    },
    account: {
      name: 'Nome-do-remetente',
      documentation: '000.000.000-00',
      kind: 'person',
    },
    links: {
      self: '',
    },
    signable: true,
  },
  {
    key: 'be4a134d-b14a-47c9-9c2d-ddbfcb5803e5',
    deadline: moment.now(),
    documentsCount: 1,
    document: {
      contentName: 'Nome-do-documento.pdf',
      signAs: ['sign'],
    },
    account: {
      name: 'Nome-do-remetente',
      documentation: '000.000.000-00',
      kind: 'person',
    },
    links: {
      self: '',
    },
    signable: true,
  },
];

export default FAKE_BATCHES;
